/** 逻辑 field key：模型供应商 + Token 配额 */
export const MS_PROVIDER_FIELD_KEYS = {
  strategy: 'ms.strategy',
  strategyDisplay: 'ms.strategyDisplay',
  /** 计价模式：所选计费项是否子资源计价（隐藏字段，驱动 Token 总量 vs 输入/输出展示） */
  useSubResourcePricing: 'ms.useSubResourcePricing',
  billingTotalTokens: 'ms.billingTotalTokens',
  inputTokens: 'ms.inputTokens',
  outputTokens: 'ms.outputTokens',
} as const;

export const MS_PROVIDER_FIELD_KEY_LIST = [
  MS_PROVIDER_FIELD_KEYS.strategy,
  MS_PROVIDER_FIELD_KEYS.strategyDisplay,
  MS_PROVIDER_FIELD_KEYS.useSubResourcePricing,
  MS_PROVIDER_FIELD_KEYS.billingTotalTokens,
  MS_PROVIDER_FIELD_KEYS.inputTokens,
  MS_PROVIDER_FIELD_KEYS.outputTokens,
] as const;
